<template>
  <div class="weather">
    <h2>Today Weather</h2>
    <div class="row">
      <div class="col-6">
        <div class="places" id="miami">
          <i class="wi" v-bind:class="[miamiWeatherClass]"></i>
          <h3>Miami</h3>
        </div>
      </div>
      <div class="col-6">
        <div class="places" id="south-beach">
          <i class="wi" v-bind:class="[southBeachWeatherClass]"></i>
          <h3>South Beach</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "Weather",
  data() {
    return {
      miamiLat: "25.808260",
      miamiLon: "-80.276655",
      miamiWeather: "day-sunny",
      miamiWeatherClass: "wi-night-sleet",
      southBeachLat: "25.768281473484517",
      southBeachLon: "-80.13075828552246",
      southBeachWeather: "day-sunny",
      southBeachWeatherClass: "wi-night-sleet",
    };
  },
  computed: {},
  methods: {
    loadDataMiami: async function () {
      const weatherApikey = "e7cd7118794283223387e02741f41e72";
      try {
        const response = await this.$http.get(
          "https://api.openweathermap.org/data/2.5/onecall?lat=" +
            this.miamiLat +
            "&lon=" +
            this.miamiLon +
            "&units=imperial&appid=" +
            weatherApikey
        );
        // JSON responses are automatically parsed.
        //this.time = response.data;
        console.log(response);
        let currWeather = response.data.hourly[0];
        let hour = moment.unix(currWeather.dt);
        let isDay = this.isDayFunction(hour);
        this.miamiWeatherClass = this.weatherCode2text(
          currWeather.weather[0].id,
          isDay
        );
      } catch (error) {
        console.log(error);
      }
    },
    loadDataSouthBeach: async function () {
      const weatherApikey = "e7cd7118794283223387e02741f41e72";
      try {
        const response = await this.$http.get(
          "https://api.openweathermap.org/data/2.5/onecall?lat=" +
            this.southBeachLat +
            "&lon=" +
            this.southBeachLon +
            "&units=imperial&appid=" +
            weatherApikey
        );
        // JSON responses are automatically parsed.
        //this.time = response.data;
        //console.log(response);
        let currWeather = response.data.hourly[0];
        let hour = moment.unix(currWeather.dt);
        let isDay = this.isDayFunction(hour);
        this.southBeachWeatherClass = this.weatherCode2text(
          currWeather.weather[0].id,
          isDay
        );
      } catch (error) {
        console.log(error);
      }
    },
    weatherCode2text: function (code, isDay) {
      console.log(code);
      let text = "";
      if (code < 300) {
        text = "wi-thunderstorm";
      } else if (code < 400) {
        text = "wi-sprinkle";
      } else if (code < 600) {
        text = "wi-rain";
      } else if (code < 700) {
        text = "wi-snow";
      } else if (code < 800) {
        text = "wi-fog";
      } else if (code == 800 && isDay) {
        text = "wi-day-sunny";
      } else if (code == 800 && !isDay) {
        text = "wi-night-clear";
      } else if (code == 801 && isDay) {
        text = "wi-day-cloudy";
      } else if (code == 801 && isDay) {
        text = "wi-night-partly-cloudy";
      } else if (code < 900) {
        text = "wi-cloudy";
      }
      return text;
    },
    isDayFunction: function (hour) {
      const dayStart = moment("06:00:00", "HH:mm:ss");
      const dayEnd = moment("17:00:00", "HH:mm:ss");
      return hour.isBetween(dayStart, dayEnd);
    },
  },
  created() {
    this.loadDataMiami();
    this.loadDataSouthBeach();

    this.interval = setInterval(
      function () {
        this.loadDataMiami();
        this.loadDataSouthBeach();
      }.bind(this),
      10800000
    );
  },
  beforeDestroy: function () {
    clearInterval(this.interval);
  },
};
</script>